<template>
    <rkm-modal
        extraLarge
        ref="Modal"
        title="Especialidades"
    >
        <Form
            :especialidadesModal="this.especialidadesModal"
            :infraestruturaSolicitanteId="this.infraestruturaSolicitanteId"
            :reguladorId="this.reguladorId"
            :sexoPaciente="this.sexoPaciente"
            ref="Form"
        />
        <List
            :especialidadesModal="this.especialidadesModal"
            :isEdicao="this.isEdicao"
            ref="List"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="handleSave"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>

    </rkm-modal>
</template>

<script>

// Vuex
import { mapActions, mapGetters } from 'vuex'

// Mixins
import { object } from '@/mixins'

// Components
import Form from './Form'
import List from './List'

export default {

    components: { Form, List },
    computed: {

        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        especialidadesModal: [],
    }),
    methods: {

        ...mapActions(['someAction']),
        open() {

            this.especialidadesModal = this.clone(this.especialidades);
            this.$refs.Modal.show();

        },
        handleSave() {

            this.$emit('addEspecialidade', this.especialidadesModal);
            this.$refs.Modal.hide();
        },
    },
    mixins: [ object ],
    props: {
        especialidades: { type: Array, default: () => [], },
        infraestruturaSolicitanteId: { type: [String, Number], required: true, },
        isEdicao: { type: Boolean, default: false, },
        reguladorId: { type: [String, Number], required: true, },
        sexoPaciente: { type:  [String, Number], required: true, },
    },
}
</script>